import { Navigate } from 'react-router-dom';

export function RequireAuth({ children, auth }) {
  if (!auth) return <Navigate to="/login" replace />;
  return children;
}
